import React from 'react';
import { FormattedMessage } from 'react-intl';

import { Artwork } from '@definitions/artworks.types';

import { PointTitle } from '../pdp.styles';
import { Sketch } from '../sketch';

import { Container, SketchContainer, Content, SketchDescription } from './artworkSpecs.styles';

export interface ArtworkSpecsProps {
  artwork: Artwork;
}

export const ArtworkSpecs = ({ artwork }: ArtworkSpecsProps) => {
  return (
    <Container>
      <PointTitle>
        <FormattedMessage id="artworkSpecs.title" defaultMessage="Specs:" />
      </PointTitle>
      <Content>
        <SketchContainer>
          <Sketch artwork={artwork} />
        </SketchContainer>
        <SketchDescription dangerouslySetInnerHTML={{ __html: artwork.specsDescription }} />
      </Content>
    </Container>
  );
};
